import { ActionTree } from "vuex";
import { ITransporterState } from "./state";
import { AxiosResponse } from "axios";
import { ITransporter } from "@/models";
import { apiClient } from "@/services";
import { ADD_TRANSPORTERS, ADD_ACTIVE_TRANSPORTERS } from "./mutations-types";

export const actions: ActionTree<ITransporterState, number> = {

    async fetchTransporters(context): Promise<AxiosResponse<ITransporter[]>> {
        const response = await apiClient.get<ITransporter[]>(`/transporters`);
        context.commit(ADD_TRANSPORTERS, response.data);

        return response;
    },

    async fetchActiveTransporters(context): Promise<AxiosResponse<ITransporter[]>> {
        const response = await apiClient.get<ITransporter[]>("/transporters/active");
        context.commit(ADD_ACTIVE_TRANSPORTERS, response.data);
        return response;
    },

    async toggleTransporter(context, transporterId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.put<void>(`/transporters/${transporterId}`);
        return response;
    },

    async addTransporter(context, name: string): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>("/transporters", { name });
        return response;
    },
};
